import React from 'react';
import { motion } from 'framer-motion';
import '../styles/components/CTA.css';

const CTA = () => {
  return (
    <section className="cta">
      <div
        className="cta-bg-image"
        style={{ backgroundImage: `url(https://images.unsplash.com/photo-1497366216548-37526070297c?w=1600&auto=format&fit=crop&q=80)` }}
      />
      <div className="cta-container">
        <div>
          <h2>Ready to <span>Transform Your Business?</span></h2>
          <p>
            Partner with us to build scalable, innovative digital solutions that drive measurable results and sustainable growth.
          </p>
          <motion.button
            className="cta-button"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => window.location.href = '/contact'}
          >
            Schedule a Consultation
          </motion.button>
        </div>

      </div>
    </section>
  );
};

export default CTA;
